<template>
    <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row style="margin-top: 0px;">
        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-start">
            <flat-pickr
              class="form-control border-1"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              placeholder="YYYY-MM ~ YYYY-MM"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2" class="d-flex align-items-start" style="margin-top: -3px;">
          <b-row class="d-flex align-items-center justify-content-start">
            <vue-select
              class="first-class mr-3"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
              label="title"            
              :options="firstClassList"
              :clearable="true"
              v-model="selectedFirstClass"
              placeholder="대분류(전체)"
            >
            </vue-select>
          </b-row>
        </b-col>
        <b-col xl="4" md="4" sm="4">
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
                <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
                <div v-else>
                  <i class="fa-regular fa-file-excel fa-lg"/>
                </div>
            </b-button>    
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mb-0" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="5" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          💡 각 브랜드 별로, 소비자가 기억하고 관심을 가지는 연결고리를 볼 수 있습니다.
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px;">
        <b-col  xl="1" md="1" sm="1">
           <b-form-group>
            <b-form-radio-group id="radio-group" v-model="selectedChart" buttons size="sm">
              <b-form-radio class="chart-radio" value="net" button @change="changeChart('net')" style="display: block !important; margin: 1px 1px;">
                <feather-icon icon="Share2Icon" size="16" style="margin-bottom: 1px;"/>
              </b-form-radio>
              <b-form-radio class="chart-radio" value="bar" button @change="changeChart('bar')" style="display: block !important; margin: 1px 1px;">
                <feather-icon icon="BarChart2Icon" size="16" style="margin-top: 1px; transform: rotate( 90deg );"/>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col xl="11" md="11" sm="11"></b-col>
      </b-row>
      <b-row>
        <b-col xl="2" md="2" sm="2">
          <vue-select
            class="select-brand"
            label="title"            
            :options="brandList"
            :clearable="true"
            v-model="selectedBrand1"
            placeholder="브랜드(전체)"
          >
          </vue-select>
        </b-col>
        <b-col xl="4" md="4" sm="4">
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <vue-select
            class="select-brand"
            label="title"            
            :options="brandList"
            :clearable="true"
            v-model="selectedBrand2"
            placeholder="브랜드(전체)"
          >
          </vue-select>
        </b-col>
        <b-col xl="3" md="3" sm="3">
        </b-col>
      </b-row>
      
      <!-- <b-row id="brandpinBarColor" style="display: none; margin-top: 1rem;">
        <b-col>
          <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FFB777; vertical-align: middle; margin-left: 1.5rem;"></div>
          <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">라인 브랜드</div>
          
          <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FF7070; vertical-align: middle; margin-left: 1.5rem;"></div>
          <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">상품명</div>

          <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #70B870; vertical-align: middle; margin-left: 1.5rem;"></div>
          <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">광고/인물</div>
        </b-col>
      </b-row> -->

      <b-row ref="bntPrintArea1" style="margin-top: 0px;">
        <b-col id="brandpinBarCol1" xl="6" md="6" sm="6" style="margin-left: 0rem; margin-top: 1rem; display: none;">
          <b-row style="margin-top: 0.5rem; margin-bottom: 1rem;">
            <b-col>
              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FFB777; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">라인 브랜드</div>
              
              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FF7070; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">상품명</div>

              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #70B870; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">광고/인물</div>
            </b-col>
          </b-row>
          <div class="graphic-container">
            <brand-pin-chart-bar
              :height="height"
              :barChartData="barChartData1"
              :barChartFreq="barChartFreq1"
              :barChartSub="barChartSub1"
              :barChartSubTitle="barChartSubTitle1"
              :barChartCategory="barChartCategory1"
              :totalFreq="totalFreq1"
              :isChartInit="barChartInit1"
            />
          </div>
        </b-col>
        <b-col id="brandpinBarCol2" xl="6" md="6" sm="6" style="margin-left: 0rem; margin-top: 1rem; display: none;">
          <b-row style="margin-top: 0.5rem; margin-bottom: 1rem;">
            <b-col>
              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FFB777; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">라인 브랜드</div>
              
              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FF7070; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">상품명</div>

              <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #70B870; vertical-align: middle; margin-left: 1.5rem;"></div>
              <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">광고/인물</div>
            </b-col>
          </b-row>
          <div class="graphic-container">
            <brand-pin-chart-bar
              :height="height"
              :barChartData="barChartData2"
              :barChartFreq="barChartFreq2"
              :barChartSub="barChartSub2"
              :barChartSubTitle="barChartSubTitle2"
              :barChartCategory="barChartCategory2"
              :totalFreq="totalFreq2"
              :isChartInit="barChartInit2"
            />
          </div>
        </b-col>
      </b-row>
      
      <b-row style="margin-top: 0px;">
        <b-col>
          <div ref="bntPrintArea2">
            <b-row id="brandpinNetRow1Title" style="margin-left: 0rem;">
              <div style="width: 100%; text-align: center; margin-top: 1rem;">
                <h2 style="margin-bottom: 0rem;">라인 브랜드 NAME TAG</h2>
              </div>
            </b-row>
            <b-row>
              <b-col id="brandpinNetRow1L" xl="6" md="6" sm="6"> 
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2 
                  :netChartNodes="netChartNodesSubBrand1"
                  :netChartLinks="netChartLinksSubBrand1"
                  />
                </div>
                <div v-if="this.netChartNodesSubBrand1.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand1 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesSubBrand1.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand1.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand1.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesSubBrand1.length == 2">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand1.length == 3">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand1.length > 3">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div style="color: #1951dc;">
                      👉 위 키워드들은 소비자가 브랜드를 무엇으로 기억하고 있는지 보여줍니다.
                    </div>
                  </div>
                </div>
              </b-col>  
              <b-col id="brandpinNetRow1R" xl="6" md="6" sm="6"> 
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2
                  :netChartNodes="netChartNodesSubBrand2"
                  :netChartLinks="netChartLinksSubBrand2"
                  />
                </div>
                <div v-if="this.netChartNodesSubBrand2.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand2 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesSubBrand2.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand2.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand2[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand2.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand2[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand2[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesSubBrand2.length == 2">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand2.length == 3">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand2[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesSubBrand2.length > 3">
                        • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand2[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand2[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand2[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div style="color: #1951dc;">
                      👉 위 키워드들은 소비자가 브랜드를 무엇으로 기억하고 있는지 보여줍니다.
                    </div>
                  </div>
                </div>
              </b-col>  
            </b-row>  
          </div>  
          <div ref="bntPrintArea3">
            <b-row id="brandpinNetRow2Title" style="margin-left: 0rem;">
              <div style="width: 100%; text-align: center; font-size: 1.5rem; margin-top: 1rem;">
                <h2 style="margin-bottom: 0rem;">상품명 NAME TAG</h2>
              </div>
            </b-row>      
            <b-row>
              <b-col id="brandpinNetRow2L" xl="6" md="6" sm="6" style="margin-left: 0rem;">
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2 
                  :netChartNodes="netChartNodesProduct1"
                  :netChartLinks="netChartLinksProduct1"
                  />
                </div>
                <div v-if="this.netChartNodesProduct1.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand1 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesProduct1.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct1.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct1.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct1[2].id }}</b>, 🥉<b>{{ this.netChartNodesProduct1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesProduct1.length == 2">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct1.length == 3">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct1.length > 3">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct1[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct1[2].id }}</b>, 🥉<b>{{ this.netChartNodesProduct1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col id="brandpinNetRow2R" xl="6" md="6" sm="6" style="margin-left: 0rem;">
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2 
                  :netChartNodes="netChartNodesProduct2"
                  :netChartLinks="netChartLinksProduct2"
                  />
                </div>
                <div v-if="this.netChartNodesProduct2.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand2 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesProduct2.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct2.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct2[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct2.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct2[2].id }}</b>, 🥉<b>{{ this.netChartNodesProduct2[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesProduct2.length == 2">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b> 를 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct2.length == 3">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct2[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesProduct2.length > 3">
                        • 소비자들은 <b>전체</b> 상품명에 대해 총 <b>{{ this.netChartNodesProduct2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesProduct2[1].id }}</b>, 🥈<b>{{ this.netChartNodesProduct2[2].id }}</b>, 🥉<b>{{ this.netChartNodesProduct2[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div ref="bntPrintArea4">
            <b-row id="brandpinNetRow3Title" style="margin-left: 0rem;">
              <div style="width: 100%; text-align: center; font-size: 1.5rem; margin-top: 1rem;">
                <h2 style="margin-bottom: 0rem;">광고/인물 NAME TAG</h2>
              </div>
            </b-row>   
            <b-row>
              <b-col id="brandpinNetRow3L" xl="6" md="6" sm="6" style="margin-left: 0rem;">
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2 
                  :netChartNodes="netChartNodesPersonAd1"
                  :netChartLinks="netChartLinksPersonAd1"
                  />
                </div>
                <div v-if="this.netChartNodesPersonAd1.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand1 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesPersonAd1.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd1.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd1[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd1.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd1[2].id }}</b>, 🥉<b>{{ this.netChartNodesPersonAd1[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">                    
                      <div v-if="this.netChartNodesPersonAd1.length == 2">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd1.length == 3">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd1[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd1.length > 3">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd1[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd1[2].id }}</b>, 🥉<b>{{ this.netChartNodesPersonAd1[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div style="color: #1951dc;">
                      👉 광고 모델이 브랜드의 성장에 도움이 되었는지 평가할 수 있습니다. 전체 예산 중 모델료 활용 비중, 모델계약 기간(장단기) 및 교체여부, 펫네임 활용 등을 결정할 수 있습니다.
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col id="brandpinNetRow3R" xl="6" md="6" sm="6" style="margin-left: 0rem;">
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <brand-pin-chart-net2 
                  :netChartNodes="netChartNodesPersonAd2"
                  :netChartLinks="netChartLinksPersonAd2"
                  />
                </div>
                <div v-if="this.netChartNodesPersonAd2.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
                  <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                    <div v-if="this.selectedBrand2 != null" style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesPersonAd2.length == 2">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd2.length == 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd2[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd2.length > 3">
                        • 소비자들은 <b>{{ this.selectedBrand2 }}</b>의 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd2[2].id }}</b>, 🥉<b>{{ this.netChartNodesPersonAd2[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div v-else style="margin-bottom: 4px;">
                      <div v-if="this.netChartNodesPersonAd2.length == 2">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd2.length == 3">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd2[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                      <div v-else-if="this.netChartNodesPersonAd2.length > 3">
                        • 소비자들은 <b>전체</b> 광고/인물에 대해 총 <b>{{ this.netChartNodesPersonAd2[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesPersonAd2[1].id }}</b>, 🥈<b>{{ this.netChartNodesPersonAd2[2].id }}</b>, 🥉<b>{{ this.netChartNodesPersonAd2[2].id }}</b> 로 가장 많이 검색되었습니다.
                      </div>
                    </div>
                    <div style="color: #1951dc;">
                      👉 광고 모델이 브랜드의 성장에 도움이 되었는지 평가할 수 있습니다. 전체 예산 중 모델료 활용 비중, 모델계약 기간(장단기) 및 교체여부, 펫네임 활용 등을 결정할 수 있습니다.
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'


import BrandPinChartBar from "@/views/cis-brandpin/components/BrandPinChartBar.vue";
// import BrandPinChartNet from "@/views/cis-brandpin/components/BrandPinChartNet.vue";
import BrandPinChartNet2 from "@/views/cis-brandpin/components/BrandPinChartNet2.vue";

import CisBrandPinService from "@/services/cis-brandpin.service";
import CategoryService from "@/services/category.service";

import useAppConfig from "@core/app-config/useAppConfig";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
  name: "BrandPin",
  components: {
    FlatPickr,
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BFormRadio,
    BFormRadioGroup,
    BTooltip,

    BrandPinChartBar,
    // BrandPinChartNet,
    BrandPinChartNet2,

  },
  data() {
    return {
      isPdfExporting: false,
      isXlsExporting: false,

      selectedChart: "net",

      isBusy: false,
      barChartInit1: false,
      barChartInit2: false,

      selectedDates: [],

      totalFreq1: 0,
      barChartData1: [],
      barChartFreq1: [],
      barChartSub1: [],
      barChartSubTitle1 : [],
      barChartCategory1: [],
      totalFreq2: 0,
      barChartData2: [],
      barChartFreq2: [],
      barChartSub2: [],
      barChartSubTitle2 : [],
      barChartCategory2: [],
      height: 0,

      netChartNodes1: [],
      netChartLinks1: [],

      netChartNodes2: [],
      netChartLinks2: [],

      netChartNodesSubBrand1: [], 
      netChartLinksSubBrand1: [],
      netChartNodesProduct1: [],
      netChartLinksProduct1: [],
      netChartNodesPersonAd1: [],
      netChartLinksPersonAd1: [],

      netChartNodesSubBrand2: [],
      netChartLinksSubBrand2: [],
      netChartNodesProduct2: [],
      netChartLinksProduct2: [],
      netChartNodesPersonAd2: [],
      netChartLinksPersonAd2: [],

      firstClassList: [],            
      brandList: [],

      selectedFirstClass: "",      
      selectedBrand1: null,
      selectedBrand2: null,

      selectedOptions: [],

      form: {
        monthSelect: []
      },
      configs: {
        monthSelect: {
          mode: "range",
          altFormat: 'Y-m',
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: "Y-m",
            })
          ],
          locale: {
            rangeSeparator: ' ~ '
          },
          minDate:"2018-01-01",
          maxDate: moment().endOf('month').format('YYYY-MM-DD') // new change
        }
      },
    };
  },
  computed: {
    check_selectedCategory(){
      return this.$store.getters.getSelectedCategory
    }
  },
  watch: {
    check_selectedCategory(val){
      this.abort(true, 'change category')

      this.selectedFirstClass = null;
      this.selectedBrand1 = null;
      this.selectedBrand2 = null;
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedDates)
      this.setFirstClasses();
    },
    selectedFirstClass(){
      this.selectedBrand1 = null;
      this.selectedBrand2 = null;
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedDates)
    },
    selectedDates(){
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedDates)
    },
    selectedOptions(){
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.setBrandList();
        this.loadDataBar1();
        this.loadDataBar2();
      }
    },
    selectedBrand1(){
      this.loadDataBar1();
    },
    selectedBrand2(){
      this.loadDataBar2();
    }  
  },
  methods: {
    changeChart(chart){
      var barCol1 = document.getElementById('brandpinBarCol1');
      var barCol2 = document.getElementById('brandpinBarCol2');

      // var barColor = document.getElementById('brandpinBarColor');

      var netRow1tlt = document.getElementById('brandpinNetRow1Title');
      var netRow2tlt = document.getElementById('brandpinNetRow2Title');
      var netRow3tlt = document.getElementById('brandpinNetRow3Title');

      var netRow1L = document.getElementById('brandpinNetRow1L');
      var netRow1R = document.getElementById('brandpinNetRow1R');
      var netRow2L = document.getElementById('brandpinNetRow2L');
      var netRow2R = document.getElementById('brandpinNetRow2R');
      var netRow3L = document.getElementById('brandpinNetRow3L');
      var netRow3R = document.getElementById('brandpinNetRow3R');

      if(chart == 'net'){
        barCol1.style.display = "none";
        barCol2.style.display = "none";
        // barColor.style.display = "none";

        netRow1L.style.display = "block";
        netRow1R.style.display = "block";
        netRow2L.style.display = "block";
        netRow2R.style.display = "block";
        netRow3L.style.display = "block";
        netRow3R.style.display = "block";
        netRow1tlt.style.display = "block";
        netRow2tlt.style.display = "block";
        netRow3tlt.style.display = "block";
      }else{
        barCol1.style.display = "block";
        barCol2.style.display = "block";
        // barColor.style.display = "block";

        netRow1L.style.display = "none";
        netRow1R.style.display = "none";
        netRow2L.style.display = "none";
        netRow2R.style.display = "none";
        netRow3L.style.display = "none";
        netRow3R.style.display = "none";
        netRow1tlt.style.display = "none";
        netRow2tlt.style.display = "none";
        netRow3tlt.style.display = "none";
      }
    },

    datePickerOnOpen(selectedDates, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange(selectedDates, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler(selectedDates, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35
          
          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form.monthSelect = [st_dt, en_dt]
        }
        else
          this.form.monthSelect = selectedDates;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        console.log('---------- Close ------------')
        if(this.selectedDates[0] != st_dt_str || this.selectedDates[1] != en_dt_str){
          this.selectedDates = []
          this.selectedDates.push(st_dt_str)
          this.selectedDates.push(en_dt_str)
          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })
        }
        
      }
      else
        instance.setDate([this.form.monthSelect[0], this.form.monthSelect[1]], true)
    },
    async setFirstClasses() {
      const firstClasses = await CisBrandPinService.listFirstClass({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if(firstClasses){
        if (firstClasses.data.success) {
          console.log('firstClasses.data.data')
          console.log(firstClasses.data.data)

          this.firstClassList = firstClasses.data.data;        
        }
      }
      
    },

    async setBrandList(){
      console.log("setBrandList")

      this.brandList = []
      var fistClassList = []

      if(this.selectedFirstClass != null)
        fistClassList.push(this.selectedFirstClass.id)
      
      const brandList = await CisBrandPinService.listBrand({
        ctgSq: this.$store.getters.getSelectedCategory,
        firstClassList : fistClassList
      }, source);

      if (brandList.data.success) {
        console.log('브랜드 리스트')
        console.log(brandList)

        for(const item of brandList.data.data) 
          this.brandList.push(item.title)
      }
    },   

    async loadDataBar1(){
      console.log("loadDataBar1");

      this.barChartData1 = []
      this.barChartFreq1 = []
      this.barChartSub1 = []
      this.barChartSubTitle1 = []
      this.barChartCategory1 = []
      this.barChartInit1 = false

      var fcls_sq = null

      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null

      if(this.selectedBrand1 != null)
        brand = this.selectedBrand1
      
      const response = await CisBrandPinService.getBrandPinDataBar({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand
      }, source);

      if (response && response.status === 200) {
        console.log('-- Bar1 data --')
        console.log(response)

        this.barChartInit1 = true

        // bar chart update
        var sub_brand_cnt = 0
        var product_cnt = 0
        var person_ad_cnt = 0
        var sub_brand_total = 0
        var product_total = 0
        var person_ad_total = 0
        this.barChartData1 = []
        this.barChartFreq1 = []
        this.barChartSub1 = []
        this.barChartSubTitle1 = []
        this.barChartCategory1 = []

        if(response.data.data.length > 0)
          this.totalFreq1 = response.data.data[0].total
        else
          this.totalFreq1 = 0        

        for(const item of response.data.data) {
          this.barChartData1.push(item.rate)
          this.barChartFreq1.push(item.freq)
          this.barChartSub1.push(item.sub)
          this.barChartSubTitle1.push(item.subTitle)
          this.barChartCategory1.push(item.keyword)

          if(item.subTitle == 'sub_brand')
            sub_brand_total = item.subTotal
          else if(item.subTitle == 'product')
            product_total = item.subTotal
          else if(item.subTitle == 'person_ad')
            person_ad_total = item.subTotal
        }

        // net chart update
        var group1_id = ''

        if(brand == null)
          group1_id = '전체'
        else
          group1_id = brand
        
        //////////////////////////////////////////////////////////////////////////
        this.netChartNodesSubBrand1 = []
        this.netChartLinksSubBrand1 = []
        this.netChartNodesSubBrand1.push({ id: "라인브랜드", group: 2, freq: sub_brand_total })
        var sub_brand_cnt2 = 0

        this.netChartNodesProduct1 = []
        this.netChartLinksProduct1 = []
        this.netChartNodesProduct1.push({ id: "상품명", group: 2, freq: product_total })
        var product_cnt2 = 0

        this.netChartNodesPersonAd1 = []
        this.netChartLinksPersonAd1 = []
        this.netChartNodesPersonAd1.push({ id: "광고/인물", group: 2, freq: person_ad_total })
        var person_ad_cnt2 = 0

        for(const item of response.data.data) {
          if(item.subTitle == 'sub_brand'){
            sub_brand_cnt2 += 1

            if(sub_brand_cnt2 <= 15){
              this.netChartNodesSubBrand1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'sub_brand', rank: sub_brand_cnt2})
              this.netChartLinksSubBrand1.push({ source: "라인브랜드", target: item.keyword })
            }
            
          }else if(item.subTitle == 'product'){
            product_cnt2 += 1

            if(product_cnt2 <= 15){
              this.netChartNodesProduct1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'product', rank: product_cnt2})
              this.netChartLinksProduct1.push({ source: "상품명", target: item.keyword })
            }
          }else if(item.subTitle == 'person_ad'){
            person_ad_cnt2 += 1

            if(person_ad_cnt2 <= 15){
              this.netChartNodesPersonAd1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'person_ad', rank: person_ad_cnt2})
              this.netChartLinksPersonAd1.push({ source: "광고/인물", target: item.keyword })
            }
          }
        }
      }
    },

    async loadDataBar2(){
      console.log("loadDataBar2");

      this.barChartData2 = []
      this.barChartFreq2 = []
      this.barChartSub2 = []
      this.barChartSubTitle2 = []
      this.barChartCategory2 = []
      this.barChartInit2 = false

      var fcls_sq = null

      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null

      if(this.selectedBrand2 != null)
        brand = this.selectedBrand2
      
      const response = await CisBrandPinService.getBrandPinDataBar({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand
      }, source);

      if (response && response.status === 200) {
        console.log('-- Bar2 data --')
        console.log(response)

        this.barChartInit2 = true

        // bar chart update
        var sub_brand_cnt = 0
        var product_cnt = 0
        var person_ad_cnt = 0
        var sub_brand_total = 0
        var product_total = 0
        var person_ad_total = 0
        this.barChartData2 = []
        this.barChartFreq2 = []
        this.barChartSub2 = []
        this.barChartSubTitle2 = []
        this.barChartCategory2 = []

        if(response.data.data.length > 0)
          this.totalFreq2 = response.data.data[0].total
        else
          this.totalFreq2 = 0
        

        for(const item of response.data.data) {
          this.barChartData2.push(item.rate)
          this.barChartFreq2.push(item.freq)
          this.barChartSub2.push(item.sub)
          this.barChartSubTitle2.push(item.subTitle)
          this.barChartCategory2.push(item.keyword)

          if(item.subTitle == 'sub_brand')
            sub_brand_total = item.subTotal
          else if(item.subTitle == 'product')
            product_total = item.subTotal
          else if(item.subTitle == 'person_ad')
            person_ad_total = item.subTotal
        }

        // net chart update
        var group1_id = ''

        if(brand == null)
          group1_id = '전체'
        else
          group1_id = brand

        //////////////////////////////////////////////////////////////////////////
        this.netChartNodesSubBrand2 = []
        this.netChartLinksSubBrand2 = []
        this.netChartNodesSubBrand2.push({ id: "라인브랜드", group: 2, freq: sub_brand_total })
        var sub_brand_cnt2 = 0

        this.netChartNodesProduct2 = []
        this.netChartLinksProduct2 = []
        this.netChartNodesProduct2.push({ id: "상품명", group: 2, freq: product_total })
        var product_cnt2 = 0

        this.netChartNodesPersonAd2 = []
        this.netChartLinksPersonAd2 = []
        this.netChartNodesPersonAd2.push({ id: "광고/인물", group: 2, freq: person_ad_total })
        var person_ad_cnt2 = 0

        for(const item of response.data.data) {
          if(item.subTitle == 'sub_brand'){
            sub_brand_cnt2 += 1

            if(sub_brand_cnt2 <= 15){
              this.netChartNodesSubBrand2.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'sub_brand', rank: sub_brand_cnt2})
              this.netChartLinksSubBrand2.push({ source: "라인브랜드", target: item.keyword })
            }
            
          }else if(item.subTitle == 'product'){
            product_cnt2 += 1

            if(product_cnt2 <= 15){
              this.netChartNodesProduct2.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'product', rank: product_cnt2})
              this.netChartLinksProduct2.push({ source: "상품명", target: item.keyword })
            }
          }else if(item.subTitle == 'person_ad'){
            person_ad_cnt2 += 1

            if(person_ad_cnt2 <= 15){
              this.netChartNodesPersonAd2.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'person_ad', rank: person_ad_cnt2})
              this.netChartLinksPersonAd2.push({ source: "광고/인물", target: item.keyword })
            }
          }
        }
      }
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = null;

      if(this.selectedChart == 'bar')
        ret = await ExportPDF.exportToPDF([this.$refs.bntPrintArea1], 'a4', 'l', 'brand_name_tag_' + this.getToday() + '.pdf');
      else
        ret = await ExportPDF.exportToPDF([this.$refs.bntPrintArea2, this.$refs.bntPrintArea3, this.$refs.bntPrintArea4], 'a4', 'l', 'brand_name_tag_' + this.getToday() + '.pdf');

      if (ret) {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export complete!!",
              icon: "EditIcon",
              variant: "success",
            },
          });
      }
      else {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export fail!!",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
      }

      this.isPdfExporting = false;
    }, 100),
    
    newSheet4Intro(dataOrigin, category, major, period, serviceName, brand1, brand2) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '브랜드1: ', t: "s", s: boldStyle }, { v: brand1, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '브랜드2: ', t: "s", s: boldStyle }, { v: brand2, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4Data(dataOrigin, category, major, period, brand, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '브랜드: ', t: "s", s: boldStyle }, { v: brand, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*키워드는 최대 100개까지 제공됩니다.', t: "s", s: boldStyle } ]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: stringStyle});    // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});  // 키워드
        tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});  // 검색량
        tmp_row.push({t: "s", v: data[idx].brand, s: stringStyle});    // 브랜드

        // 구분
        if (data[idx].criteria == 'sub_brand')
          tmp_row.push({t: "s", v: '라인 브랜드명', s: stringStyle});      
        else if (data[idx].criteria == 'product')
          tmp_row.push({t: "s", v: '상품명', s: stringStyle});
        else if(data[idx].criteria == 'person_ad')
          tmp_row.push({t: "s", v: '인물/광고', s: stringStyle});

        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

        if (catServResp.data.success)
          category = catServResp.data.data.title

        const period = st_dt_str + ' ~ ' + en_dt_str;

        var major = '전체';
        var brand1 = '전체';
        var brand2 = '전체';

        if (this.selectedFirstClass != null && this.selectedFirstClass.title.length > 0)
          major = this.selectedFirstClass.title;

        if (this.selectedBrand1 != null && this.selectedBrand1.length > 0)
          brand1 = this.selectedBrand1;

        if (this.selectedBrand2 != null && this.selectedBrand2.length > 0)
          brand2 = this.selectedBrand2;

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, major, period, 'BRAND NAME TAG', brand1, brand2), 
                                     '데이터 개요') 

        var fcls_sq = null
        
        if(this.selectedFirstClass != null)
          fcls_sq = this.selectedFirstClass.id
        
        var brand_list = [brand1 == '전체' ? null : brand1, brand2 == '전체' ? null : brand2];

        for (const idx in brand_list) {
          const brdResp = await CisBrandPinService.getBrandPinDataBarExp({
            startDate : this.selectedDates[0],
            endDate : this.selectedDates[1],
            ctgSq : this.$store.getters.getSelectedCategory,
            fclsSq : fcls_sq,
            brand : brand_list[idx]
          }, source);

          if (brdResp && brdResp.status === 200) {
            var brandRelKeywords = [];

            for(const item of brdResp.data.data) {
              brandRelKeywords.push({
                keyword: item.keyword,
                freq: item.freq,
                brand: item.brand,
                criteria: item.subTitle
              });     
            }

            var brand = brand_list[idx] === null ? '전체' : brand_list[idx];

            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4Data(dataOrigin, category, major, period, brand, ['검색량', '브랜드', '구분'], brandRelKeywords), 
                                         '브랜드' + (Number(idx) + 1) + ' 연관어')
          }
        }   

        XLSX.writeFile(workbook, 'brand_name_tag_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
  },

  mounted(){
    console.log('----- mounted -----')

    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);
  },

  destroyed() {
    console.log('----- destroyed -----')
    
    this.abort(false, 'destoryed')
  },

  async created() {
    console.log('----- create -----')

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'brandpin' })

    this.selectedFirstClass = null;
    this.selectedBrand1 = null;
    this.selectedBrand2 = null;
    this.selectedOptions.push(this.$store.getters.getSelectedCategory)
    this.selectedOptions.push(this.selectedFirstClass)
    this.selectedOptions.push(this.selectedDates)
    this.setFirstClasses();

    var st_dt = this.$store.getters.getSelectedPeriodSt
    var en_dt = this.$store.getters.getSelectedPeriodEn

    if (st_dt.length == 0 || en_dt.length == 0) {
      en_dt = moment().add(-2, 'days').toDate() // 데이터 업데이트 시점을 고려
      st_dt = new Date(en_dt)

      st_dt.setMonth(en_dt.getMonth() - 11)
    }

    this.form.monthSelect = [st_dt, en_dt]

    var st_dt_str = moment(st_dt).format("YYYY-MM")
    var en_dt_str = moment(en_dt).format("YYYY-MM")

    this.selectedDates.push(st_dt_str)
    this.selectedDates.push(en_dt_str) 
  },
};

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.flat-picker {
  width: 263px;
}


#brandpinBarCol1 .apexcharts-canvas .apexcharts-text, #brandpinBarCol1 .apexcharts-canvas .apexcharts-tooltip-text, #brandpinBarCol1 .apexcharts-canvas .apexcharts-datalabel-label, #brandpinBarCol1 .apexcharts-canvas .apexcharts-datalabel 
,#brandpinBarCol2 .apexcharts-canvas .apexcharts-text, #brandpinBarCol2 .apexcharts-canvas .apexcharts-tooltip-text, #brandpinBarCol2 .apexcharts-canvas .apexcharts-datalabel-label, #brandpinBarCol2 .apexcharts-canvas .apexcharts-datalabel 
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#brandpinBarCol1 .graphic-container
,#brandpinBarCol2 .graphic-container {
  min-height: 600px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}

.first-class .vs__dropdown-menu,
.select-brand .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}


.mb-1 .sticky-top{
  align-self: flex-start;
}


.chart-radio .btn {
  display: block;
}

.chart-radio.btn.btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}

.chart-radio.btn.btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  box-shadow: 0 6px 30px -6px #002896;
  font-weight: 600;
  font-size: 1.3rem;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}



</style>
